import { BaseRequestFailureActionCreator, BaseRequestSuccessActionCreator } from "types";

// ------------------------------------
// Constants
// ------------------------------------
export const IPSEC_VENDORS_GET_REQUEST = "IPSEC_VENDORS_GET_REQUEST";
export const IPSEC_VENDORS_GET_SUCCESS = "IPSEC_VENDORS_GET_SUCCESS";
export const IPSEC_VENDORS_GET_FAILURE = "IPSEC_VENDORS_GET_FAILURE";
export const IPSEC_VENDORS_CLEAR = "IPSEC_VENDORS_CLEAR";

// ------------------------------------
// Actions
// ------------------------------------
export function request(
  resolve?: (value?: any) => void,
  reject?: (reason?: any) => void
) {
  return {
    type: IPSEC_VENDORS_GET_REQUEST,
    resolve,
    reject,
  };
}

export const requestSuccess: BaseRequestSuccessActionCreator<any> = (data) => {
  return {
    type: IPSEC_VENDORS_GET_SUCCESS,
    data,
  };
};

export const requestFailure: BaseRequestFailureActionCreator = (error) => {
  return {
    type: IPSEC_VENDORS_GET_FAILURE,
    error,
  };
};

export function clear() {
  return {
    type: IPSEC_VENDORS_CLEAR,
  };
}
